import 'css-chunksrc/client/pages/utilityPage/styles.scss';export default {
  "utilityPage": "_utilityPage_8rjvt_1",
  "title": "_title_8rjvt_8",
  "header": "_header_8rjvt_15",
  "profileNavigation": "_profileNavigation_8rjvt_24",
  "main": "_main_8rjvt_34",
  "content": "_content_8rjvt_41"
};